import React from 'react';
import PropTypes from 'prop-types';
import Image from 'gatsby-image';

const ImageAndText = ({ image, text  }) => (
  <div className="template__imageandtext">
      <div className="template__imageandtext-wrapper">
      <div className="template__imageandtext-image">
          {image && image.localFile && <Image sizes={image.localFile.childImageSharp.sizes} />}
      </div>
      <div className="template__imageandtext-text">
          <div
            className="template__imageandtext-text-wrapper"
            dangerouslySetInnerHTML={{
              __html: text.html,
            }}
        />
      </div>
</div>
  </div>
);

ImageAndText.propTypes = {
  /** Docgen prop description */

};

export default ImageAndText;

export const query = graphql`
  fragment ImageAndTextFragment on PrismicCaseStudyBodyImageAndText {
    slice_type
    primary {
        image {
          localFile {
            childImageSharp {
              sizes(maxWidth: 469, quality: 90) {
                ...GatsbyImageSharpSizes_withWebp
              }
            }
          }
        }
      text {
        html
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/CaseStudy/ImageAndText/ImageAndText.js